import React from 'react';
import PropTypes from 'prop-types';

import BBSocialMediaEmbedFacebook from './BBSocialMediaEmbedFacebook';
import BBSocialMediaEmbedInstagram from './BBSocialMediaEmbedInstagram';
import BBSocialMediaEmbedTwitter from './BBSocialMediaEmbedTwitter';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

// TODO: use CSS modules.
const BBSocialMediaEmbed = ({
  alignment = 'center',
  provider,
  behaviorSettings = null,
  uuid = null,
  ...props
}) => {
  props.postID = props.postID ?? '';
  props.postURL = props.postURL ?? '';

  const classes = [
    'bb',
    styles['bb-social-media-embed'],
    provider,
    generateClassNameByBehaviorSettings(behaviorSettings),
  ];

  return (
    <div className={classes.join(' ')} id={uuid}>
      <div className="container">
        <div className={styles[`bb-social-media-embed--align-items-${alignment}`]}>
          {provider === 'facebook' && (
            <BBSocialMediaEmbedFacebook {...props} socialMediaType={provider} />
          )}

          {provider === 'instagram' && (
            <BBSocialMediaEmbedInstagram {...props} socialMediaType={provider} />
          )}

          {provider === 'twitter' && (
            <BBSocialMediaEmbedTwitter {...props} socialMediaType={provider} />
          )}
        </div>
      </div>
    </div>
  );
};

BBSocialMediaEmbed.propTypes = {
  provider: PropTypes.oneOf(['facebook', 'instagram', 'twitter']).isRequired,
  postURL: PropTypes.string,
  postID: PropTypes.string,
  alignment: PropTypes.oneOf(['left', 'right', 'center', undefined]),
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBSocialMediaEmbed;
